// Notification Service - AgentBheem ERP
import api from '@/services/api/client'

export interface Notification {
  id: string
  client_id?: string
  user_id?: string
  alert_id?: string
  notification_type: 'alert' | 'reminder' | 'report' | 'system'
  channel: 'email' | 'whatsapp' | 'sms' | 'in_app' | 'slack'
  subject?: string
  message?: string
  template_id?: string
  recipient_email?: string
  recipient_phone?: string
  status: 'pending' | 'sent' | 'delivered' | 'failed' | 'bounced' | 'read'
  sent_at?: string
  delivered_at?: string
  read_at?: string
  error_message?: string
  retry_count: number
  created_at: string
  extra_data?: Record<string, unknown>
}

export interface NotificationListResponse {
  items: Notification[]
  total: number
  page: number
  page_size: number
  total_pages: number
}

export interface NotificationKPIs {
  total_sent: number
  pending: number
  delivered: number
  failed: number
  bounced: number
  delivery_rate: number
  by_channel: Record<string, number>
  by_type: Record<string, number>
}

export const notificationService = {
  /**
   * Get notifications list
   * Endpoint: GET /api/v1/ss-client-management/notifications/
   */
  async getNotifications(params?: {
    page?: number
    page_size?: number
    notification_type?: string
    status?: string
  }): Promise<NotificationListResponse> {
    const response = await api.get<NotificationListResponse>(
      '/v1/ss-client-management/notifications/',
      { params }
    )
    return response.data
  },

  /**
   * Mark notification as read
   * Endpoint: POST /api/v1/ss-client-management/notifications/{id}/read
   */
  async markAsRead(notificationId: string): Promise<{ success: boolean }> {
    const response = await api.post(`/v1/ss-client-management/notifications/${notificationId}/read`)
    return response.data
  },

  /**
   * Mark notification as delivered
   * Endpoint: POST /api/v1/ss-client-management/notifications/{id}/delivered
   */
  async markAsDelivered(notificationId: string): Promise<{ success: boolean }> {
    const response = await api.post(`/v1/ss-client-management/notifications/${notificationId}/delivered`)
    return response.data
  },

  /**
   * Get notification KPIs
   * Endpoint: GET /api/v1/ss-client-management/notifications/kpis
   */
  async getKPIs(days = 30): Promise<NotificationKPIs> {
    const response = await api.get<NotificationKPIs>(
      '/v1/ss-client-management/notifications/kpis',
      { params: { days } }
    )
    return response.data
  },
}
